'use strict';
module.exports = require('./MegaMenu.vue');